// extracted by mini-css-extract-plugin
module.exports = {"content":"Stores_content__z9xGN","cardWrapper":"Stores_cardWrapper__VpGRt","imageWrapper":"Stores_imageWrapper__17o0k","divider":"Stores_divider__VRfgh"};